import { Step } from './components/stepper/stepper';

export const STEPS: Step[] = [
    {
      id: 1,
      label: 'stepper.step1.title',
      state: '',
      isCurrenPosition: false
    },
    {
      id: 2,
      label: 'stepper.step2.title',
      state: '',
      isCurrenPosition: false
    },
    {
      id: 3,
      label: 'stepper.step3.title',
      state: '',
      isCurrenPosition: false
    },
    {
      id: 4,
      label: 'stepper.step4.title',
      state: '',
      isCurrenPosition: false
    }
  ];